import { createApi } from '@reduxjs/toolkit/query/react';
import rtkBaseQuery from '../../../utils/rtk-base-query';

export const newsApi = createApi({
  reducerPath: 'newsApi',
  baseQuery: rtkBaseQuery({ baseUrl: '/api/v2' }),
  endpoints: (builder) => ({
    getNewsDetails: builder.query({
      query: ({ newsid }) => ({
        url: `/news/getNewsDetails?newsid=${newsid}`,
      }),
    }),
    getMostReadNews: builder.query({
      query: () => ({ url: '/news/getMostReadNews' }),
    }),
    getLatestNews: builder.query({
      query: () => ({ url: '/news/getLatestNews' }),
    }),
    getNewsCompensationInDepthArticles: builder.query({
      query: () => ({ url: '/news/compensation/indeptharticles' }),
    }),
  }),
});

export const newsApiOld = createApi({
  reducerPath: 'newsApiOld',
  baseQuery: rtkBaseQuery({ baseUrl: '/api/v1' }),
  endpoints: (builder) => ({
    getLatestNewsFiltered: builder.query({
      query: ({ params }) => ({
        url: '/news/GetLatestNewsFiltered',
        method: 'POST',
        body: params,
      }),
    }),
  }),
});

export const { useGetNewsDetailsQuery, useGetMostReadNewsQuery, useGetLatestNewsQuery } = newsApi;
export const { useGetLatestNewsFilteredQuery } = newsApiOld;
